/* eslint-disable */
import PropTypes from 'prop-types';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const SpeedDialActionWrapperPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The i18n data
   */
  data: PropTypes.object,

  /**
   * The icon
   */
  icon: PropTypes.node,

  /**
   * The onClick handler
   */
  onClick: PropTypes.func,

  /**
   * The onClick handler
   */
  open: PropTypes.bool,

  /**
   * The services
   */
  services: ServicesContextPropTypes.services,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default SpeedDialActionWrapperPropTypes;
